import { Fragment } from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Fecon.</Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
};

export default Footer;
